// hnb-frontend/src/pages/NotFoundPage.tsx

import React from 'react';
import { Link } from 'react-router-dom';

export default function NotFoundPage() {
  return (
    <main
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '32px',
        background: '#f8fafc',
      }}
    >
      <div
        style={{
          maxWidth: '560px',
          textAlign: 'center',
          display: 'flex',
          flexDirection: 'column',
          gap: '16px',
        }}
      >
        <p
          style={{
            margin: 0,
            fontSize: '0.95rem',
            fontWeight: 700,
            color: '#6366f1',
            textTransform: 'uppercase',
            letterSpacing: '0.04em',
          }}
        >
          404
        </p>

        <h1 style={{ margin: 0, fontSize: '2.4rem', color: '#111827' }}>
          Page not found
        </h1>

        <p style={{ margin: 0, color: '#6b7280', lineHeight: 1.7 }}>
          The page you requested does not exist in the current HnB frontend
          prototype route map.
        </p>

        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            gap: '12px',
            flexWrap: 'wrap',
          }}
        >
          <Link
            to="/"
            style={{
              textDecoration: 'none',
              background: '#111827',
              color: '#ffffff',
              padding: '12px 18px',
              borderRadius: '10px',
              fontWeight: 600,
            }}
          >
            Go home
          </Link>

          <Link
            to="/staff/dashboard"
            style={{
              textDecoration: 'none',
              border: '1px solid #d1d5db',
              color: '#111827',
              padding: '12px 18px',
              borderRadius: '10px',
              fontWeight: 600,
              background: '#ffffff',
            }}
          >
            Open dashboard
          </Link>
        </div>
      </div>
    </main>
  );
}